import React, { Component, Fragment } from 'react'
import { Popover } from 'antd'
import { dateFormat, moneyColumn } from '../../../modules/Utils'
import moment from 'moment/moment'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import CustomTable from '../../../elements/Table/CustomTable'
import { Link } from 'react-router-dom'

class PaymentsList extends Component {
  async componentDidMount () {
    await this.props.fetch()
  }

  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => (
        <Link
          to={`/clients/payments/${original._key}/add`}
          style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      ),
      width: 150,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ value }) => dateFormat(moment(value)),
      width: 100,
    },

    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      Cell: ({ value }) => moneyColumn(value),
      width: 100,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      style: { textAlign: 'center' },
      width: 100,
    },
    {
      Header: 'Payment Details',
      accessor: 'notes',
      Cell: ({ original, value }) => (
        <Popover
          content={original.notes}
          placement="bottom"
          disabled={true}
          title="Notes">
          {value}
        </Popover>
      ),
      hideable: true,
    },
    {
      Header: 'Payer',
      accessor: 'remittance.order',
      width: 250,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 250,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Bank Account',
      accessor: 'bank.title',
      width: 300,
      hideDefault: false,
      hideable: true,
    },
  ]

  render () {
    const { fetching, fetch, list, onChangeCompany, company } = this.props
    return (
      <Fragment>
        <CustomTable
          ExtraOptionsButtons={() => (
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              placeholder={'Filter by a company'}
              size={'small'}
              style={{ width: '450px', paddingRight: 20, float: 'right' }}
            />
          )}
          columns={this.columns.map(c => ({
            style: { textAlign: 'center' },
            ...c,
          }))}
          data={list.filter((i) => i.transactionType !== 'Group Transaction')}
          fetching={fetching}
          fetch={fetch}
          isFilterable={true}
          defaultPageSize={20}
          show={{ extraColumns: true }}
          style={{ minHeight: '512px', fontSize: 11 }}
        />
      </Fragment>
    )
  }
}

export default PaymentsList
